import * as React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from 'react-bootstrap';
import { II18nMessages } from '../../../../../../services/branding/models';
import { map, flow } from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { IStore } from '../../../../../../redux/IStore';
import { IQuoteState } from '../../../../../../services/quote/models';

interface IProps {
  i18n: II18nMessages;
  steps: object;
  currentStep: string;
  quote: IQuoteState;
}

class QuoteWizardNavigation extends React.Component<IProps, any> {
  constructor(props) {
    super(props);

    this.renderItem = this.renderItem.bind(this);
  }

  private renderItem(item, key) {
    const { currentStep, quote: { application : { steps = [] } } } = this.props;

    const isEnabled = steps.indexOf(item.key) > -1;

    let className = isEnabled ? '' : 'disabled';

    if (item.key === currentStep) {
      className += ' active';
    }

    return (
      <li key={key} className={className}>
        <Link to={isEnabled ? item.route : '#'}>
          <Badge>{key + 1}</Badge> {item.title}
        </Link>
      </li>
    );
  }

  public render() {
    const { steps } = this.props;

    return (
      <div className="wizard">
        <div className="container">
          <ul>
            {map(steps, this.renderItem)}
          </ul>
        </div>
      </div>
    );
  }
}

export default flow([
  connect(
    (state: IStore) => ({
      quote: state.quote,
    }),
  ),
  withRouter,
])(QuoteWizardNavigation);
